import React from 'react';

export const SubscriptionsMusic = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='white' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9 3C7.895 3 7 3.895 7 5V15.1758C6.67908 15.0608 6.3409 15.0014 6 15C5.20435 15 4.44129 15.3161 3.87868 15.8787C3.31607 16.4413 3 17.2044 3 18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21C6.79565 21 7.55871 20.6839 8.12132 20.1213C8.68393 19.5587 9 18.7956 9 18V10C9 9.448 9.448 9 10 9H17C17.552 9 18 9.448 18 10V15.1758C17.6791 15.0608 17.3409 15.0014 17 15C16.2044 15 15.4413 15.3161 14.8787 15.8787C14.3161 16.4413 14 17.2044 14 18C14 18.7956 14.3161 19.5587 14.8787 20.1213C15.4413 20.6839 16.2044 21 17 21C17.7956 21 18.5587 20.6839 19.1213 20.1213C19.6839 19.5587 20 18.7956 20 18V5C20 3.895 19.105 3 18 3H9Z' />
    </svg>
  );
};
